import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { DateChangeEvent, SchedulerComponent, SchedulerEvent, SlotRange } from '@progress/kendo-angular-scheduler';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { filter, finalize } from 'rxjs';
import _, { head } from 'lodash';
import {
  displayDate,
  endOfWorkWeek,
  formatEndToAPI,
  formatStartToAPI,
  sampleData,
  startOfWorkWeek,
} from 'src/app/modules/administration/constants/scheduler';
import { AbstractComponent } from 'src/app/shared/components/abstract-component';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import { MyEvent, SchedulerEditService } from '../../../shared/services/scheduler-edit.service';
import { FormGroup } from '@angular/forms';
import { ProviderManagementService } from 'src/app/modules/provider-management/services/provider-management.service';
import { parseDate } from '@progress/kendo-angular-intl';
import { AdminService } from 'src/app/modules/administration/services/admin.service';
import { LoadingService } from 'src/app/services/loading.service';
import moment from 'moment';
import { ISchedulerResponse } from 'src/app/modules/provider-management/interfaces/get-scheduler-response';
import { data } from '../../models/schedule-meeting-models/schudel-json-data';
import { ICurrentEventData } from 'src/app/modules/provider-management/interfaces/current-event-data';
import { SessionType } from 'src/app/modules/provider-management/enums/schedule-enums';
import { DashboardPMResponse } from 'src/app/modules/provider-management/interfaces/pm-dashboard.response';

@Component({
  selector: 'app-schedules-timeline',
  templateUrl: './schedules-timeline.component.html',
  styleUrls: ['./schedules-timeline.component.scss'],
  standalone: false
})
export class SchedulesTimelineComponent
  extends AbstractComponent
  implements OnInit, OnChanges {
  public selectedDate: any;
  public events: SchedulerEvent[] = sampleData;
  public xMark: SVGIcon = this.customFaIcon(faXmark);
  @Input() public studentsSelected: boolean;
  @Input() selecteStudentdMandates: any;
  @Input() selectedMandates: any;
  @Input() editStartDate: Date;
  @Input() compareMandatesGridView: any;
  @Input() editStartTime: any;
  @Input() studentSk: string;
  @Input() editSelectedMandates: ICurrentEventData[];
  public user: User;
  public startTime: string = "08:00";
  public endTime: string = "21:00";
  public group: any = {
    resources: ['Students'],
    orientation: 'vertical',
  };
  public inlineTop: number = 0;
  public inlineLeft: number = 0;
  selectedSlotStart!: Date;
  selectedSlotEnd!: Date;
  @ViewChild('scheduler') scheduler!: SchedulerComponent;
  @Input() isEditingSession: boolean;
  @Input() schedulesFormGroup: FormGroup;
  public resources: any[] = [];
  readonly iEPMeetingAttendanceNumber: number = 2;
  readonly nYCPSAuthorizedTraining: number = 3;
  readonly meetingWithSchoolStaff: number = 4;
  eventsDetails: any;
  showEvent: boolean;
  scheduleText: string;
  eventData: any[];
  checkStatus: boolean;
  constructor(
    public schedulerEditService: SchedulerEditService,
    public providerService: ProviderManagementService,
    public loaderService: LoadingService,
    public adminservice: AdminService,
    public cdref: ChangeDetectorRef,
    private authStore: AuthStore
  ) {
    super();

    this.authStore.UserInfo$.pipe(filter((user: User) => !!user)).subscribe(
      (userInfo: User) => {
        this.user = userInfo;

        //Dev TODO: Will remove hardcoded data once API is integrated. reference that how UI Needed data.

        // Use a common `resourceKey` so events can map to either provider or student rows.
        // this.resources = [
        //   {
        //     name: 'Students',
        //     data: data.map(item => {
        //       if (item.rowType === 'Provider') {
        //         return {
        //           resourceName: item.providerName,
        //           providerSk: item.providerSk,
        //           resourceKey: item.providerSk,
        //           rowType: item.rowType
        //         };
        //       }

        //       if (item.rowType === 'Student') {
        //         return {
        //           resourceName: item.studentName,
        //           nycId: item.nycId,
        //           dob: item.dob,
        //           grade: item.grade,
        //           disability: item.disability,
        //           studentSk: item.studentSk,
        //           resourceKey: item.studentSk,
        //           rowType: item.rowType
        //         };
        //       }

        //       return null;
        //     }).filter(Boolean), // remove nulls

        //     field: 'resourceKey',      // event → resource mapping field
        //     valueField: 'resourceKey', // resource unique key
        //     textField: 'resourceName'
        //   }
        // ];

        // this.resources =
        // [
        //     {
        //       name: 'Students',
        //       data: [
        //         {
        //           resourceName: this.user?.username,
        //           providerSk: this.user?.providerSk,
        //         },
        //         // {
        //         //   resourceName: 'Delaney Durham',
        //         //   nycId: '111111111',
        //         //   dob: '03/31/2008',
        //         //   grade: '11',
        //         //   disability: 'Orthopedic Impairment',
        //         //   providerSk: '3242343243243-dsfdsfdsf-223423-sdasd',
        //         // },
        //         // {
        //         //   resourceName: 'Kaelyn Foster',
        //         //   nycId: '222222222',
        //         //   dob: '07/10/2008',
        //         //   grade: '12',
        //         //   disability: 'Multiple Disabilities',
        //         //   providerSk: '3242343243243-dsfdsfdsf-223423-sdasd',
        //         // },
        //         // {
        //         //   resourceName: 'Clayton Galvan',
        //         //   nycId: '333333333',
        //         //   dob: '02/18/2009',
        //         //   grade: '13',
        //         //   disability: 'Other Health Impairment',
        //         //   providerSk: '3242343243243-dsfdsfdsf-223423-sdasd',
        //         // },
        //       ],
        //       field: 'providerSk', //Field to be mapped from event to resource
        //       valueField: this.user?.providerSk,
        //       textField: 'resourceName',
        //     },
        //   ];


        // [
        //   {
        //     name: 'Students',
        //     data: [
        //       {
        //         resourceName: this.user?.username,
        //         providerSk: this.user?.providerSk,
        //       },
        //       // {
        //       //   resourceName: 'Delaney Durham',
        //       //   nycId: '111111111',
        //       //   dob: '03/31/2008',
        //       //   grade: '11',
        //       //   disability: 'Orthopedic Impairment',
        //       //   providerSk: '3242343243243-dsfdsfdsf-223423-sdasd',
        //       // },
        //       // {
        //       //   resourceName: 'Kaelyn Foster',
        //       //   nycId: '222222222',
        //       //   dob: '07/10/2008',
        //       //   grade: '12',
        //       //   disability: 'Multiple Disabilities',
        //       //   providerSk: '3242343243243-dsfdsfdsf-223423-sdasd',
        //       // },
        //       // {
        //       //   resourceName: 'Clayton Galvan',
        //       //   nycId: '333333333',
        //       //   dob: '02/18/2009',
        //       //   grade: '13',
        //       //   disability: 'Other Health Impairment',
        //       //   providerSk: '3242343243243-dsfdsfdsf-223423-sdasd',
        //       // },
        //     ],
        //     field: 'providerSk', //Field to be mapped from event to resource
        //     valueField: this.user?.providerSk,
        //     textField: 'resourceName',
        //   },
        // ];
      }
    );
  }

  getGroupSize(data: string): string {
    return data !== undefined ? data : '0';
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.loaderService.show();
    if (this.isEditingSession) {
      this.selectedDate = this.editStartDate;
    }
    if (this.studentsSelected) {
      const payload: {
        providerSK: string;
        providerName: string;
        startDate: string;
        endDate: string;
        studentSk: string;
        grade?: string;
      } = {
        providerSK: this.user?.providerSk,
        providerName: this.user?.uid,
        startDate: this.isEditingSession ? formatStartToAPI(this.editStartDate) : startOfWorkWeek,
        endDate: this.isEditingSession ? formatStartToAPI(this.editStartDate) : startOfWorkWeek,
        studentSk: this.studentSk,
        grade: this.selecteStudentdMandates?.grade,
      }
      this.providerService.getStudentEvaluatorSchedules(payload).pipe(
        finalize(() => {
          this.loaderService?.hide();
        })
      ).subscribe((response: any) => {
        this.bindResources(response);
        this.eventsDetails = response?.flatMap(parent =>
          (parent.blocks || []).map(block => {
            const startDate: Date = new Date(block.startTime);
            const endDate: Date = new Date(block.endTime);

            // Set `resourceKey` so the event binds to the correct resource row
            const resourceKey: string = parent.rowType === 'Evaluator' ? parent.providerSk : parent.studentSk;
            const resourceType: string = parent.rowType === 'Evaluator' ? 'Evaluator' : 'Student';

            return {
              id: block.meetingSk ?? `${parent.studentSk}-${block.startTime}`,
              resourceKey,
              resourceType,
              groupSize: null, // not available in block → keep null
              title: block?.serviceType || block?.courseName,
              start: startDate,
              end: endDate,
              location: block?.location, // not available in block
              studentName: block?.studentName,
              description: parent?.studentName || parent?.providerName,
              language: block?.isProviderSession ? 'EN' : null,
              serviceType: block?.serviceType,
              studentMandates: null,
              dataItem: {
                ...block,
                ...parent
              },
              isAllDay: false,
              sessionType: block?.isProviderSession ? 1 : 2,
              sessionTypeName: block?.isProviderSession ? 'Provider Session' : 'Student Session'
            };
          })
        );
        this.loaderService?.hide();
      });
    }
    else {

      const mandateSkList: string[] = this.compareMandatesGridView?.length > 0
        ? this.compareMandatesGridView
          .map(item => item?.mandateDetails?.mandateSk)
          .filter(Boolean) : this.editSelectedMandates?.map(item => item?.mandateSk)
            .filter(Boolean);
      const payload: {
        providerSK: string;
        providerName: string;
        startDate: string;
        endDate: string;
        mandateSk: string[];
      } = {
        providerSK: this.user?.providerSk,
        providerName: this.user?.uid,
        startDate: this.isEditingSession ? formatStartToAPI(this.editStartDate) : startOfWorkWeek,
        endDate: this.isEditingSession ? formatStartToAPI(this.editStartDate) : startOfWorkWeek,
        mandateSk: mandateSkList
      }
      this.providerService.getStudentProviderSchedules(payload).pipe(
        finalize(() => {
          this.loaderService?.hide();
        })
      ).subscribe((response: any) => {
        this.bindResources(response);
        this.eventsDetails = response?.flatMap(parent =>
          (parent.blocks || []).map(block => {
            const startDate: Date = new Date(block.startTime);
            const endDate: Date = new Date(block.endTime);

            // Set `resourceKey` so the event binds to the correct resource row
            const resourceKey: string = parent.rowType === 'Provider' ? parent.providerSk : parent.studentSk;
            const resourceType: string = parent.rowType === 'Provider' ? 'Provider' : 'Student';
            const formjson: any = block?.formJSON ? JSON.parse(block.formJSON) : null;
            return {
              id: block.meetingSk ?? `${parent.studentSk}-${block.startTime}`,
              resourceKey,
              resourceType,
              groupSize: formjson?.groupSize, // not available in block → keep null
              title: block?.serviceType || block?.courseName,
              start: startDate,
              end: endDate,
              description: parent?.studentName || parent?.providerName,
              language: block?.isProviderSession ? 'EN' : null,
              serviceType: block?.serviceType,
              location: block?.location, // not available in block
              studentMandates: formjson?.studentMandates,
              sessionType: formjson?.sessionType?.id,
              dataItem: {
                ...block,
                ...parent
              },
              isAllDay: false,
              sessionTypeName: block?.sessionTypeName,
            };
          })

        );

        this.loaderService?.hide();
      });
      this.cdref?.detectChanges();
    }
  }
  bindResources(response: any): void {
    if (response) {
      this.resources = [
        {
          name: 'Students',
          data: response.map(item => {
            if (item?.rowType === 'Provider' || item?.rowType === 'Evaluator') {
              return {
                resourceName: item?.providerName,
                providerSk: item?.providerSk,
                resourceKey: item?.providerSk,
                rowType: item?.rowType
              };
            }

            if (item?.rowType === 'Student') {
              return {
                resourceName: item?.studentName,
                nycId: item?.nycId,
                dob: item?.dob,
                grade: item?.grade,
                disability: item?.disability,
                studentSk: item?.studentSk,
                resourceKey: item?.studentSk,
                rowType: item?.rowType
              };
            }

            return null;
          }).filter(Boolean), // remove nulls

          field: 'resourceKey',      // event → resource mapping field
          valueField: 'resourceKey', // resource unique key
          textField: 'resourceName'
        }
      ];
    }
  }

  private readonly MIN_PARTS_LENGTH: number = 2;
  private readonly RATIO_PART_INDEX: number = 1;

  getEventColor = (event: any): string => {
    if (this.studentsSelected) {
      switch (event?.event?.dataItem?.dataItem?.rowType) {
        case 'Student':
          return 'k-event-normal';
        default:
          return 'k-event1';
      }
    } else {
      switch (event?.event?.dataItem?.dataItem?.rowType) {
        case 'Student':
          return 'k-event-normal';
        case 'IEP':
          return 'k-event2';
        default:
          if (event?.event?.dataItem?.sessionType === 1) {
            if (this.isGroupFull(event?.event?.dataItem?.groupSize,
              event?.event?.dataItem?.studentMandates)) {
              return 'k-event4';
            } else {
              return 'k-event3';
            }
          } else {
            return 'k-event3';
          }
      }
    }
  }
  isGroupFull = (groupSize: string, studentMandates: DashboardPMResponse[]): boolean => {
    return Number(groupSize) !== studentMandates?.length;
  };

  isSessionIncomplete = (sessionLabel: string): boolean => {
    if (!sessionLabel) return false;

    const parts: string[] = sessionLabel.split('-');
    if (parts.length < this.MIN_PARTS_LENGTH) return false;

    const ratioPart: string = parts[this.RATIO_PART_INDEX].trim(); // "1/3"
    const [current, total]: number[] = ratioPart.split('/').map(Number);

    return current !== total;
  }


  openScheduler(): void {
    this.providerService.setBindScheduleDetails({
      start: this.selectedSlotStart,
      end: this.selectedSlotEnd,
      isSelected: true,
    });
    this.checkStatus = false;
    // Logic to open scheduler form/modal goes here
  }
  ngOnInit(): void {
    this.loaderService?.show();


    this.providerService.scheduleTimeDetails$.subscribe((data) => {
      if (data) {
        this.selectedDate = data?.startDate;
        this.loaderService.show();
        if (this.studentsSelected) {
          const payload: {
            providerSK: string;
            providerName: string;
            startDate: string;
            endDate: string;
            studentSk: string;
            grade?: string;
          } = {
            providerSK: this.user?.providerSk,
            providerName: this.user?.uid,
            startDate: formatStartToAPI(data.startDate as any),
            endDate: formatStartToAPI(data.startDate as any),
            studentSk: this.studentSk,
            grade: this.selecteStudentdMandates?.grade,
          }

          this.providerService.getStudentEvaluatorSchedules(payload).pipe(
            finalize(() => {
              this.loaderService?.hide();
            })
          ).pipe(
            finalize(() => {
              this.loaderService?.hide();
            })
          ).subscribe((response: any) => {
            this.bindResources(response);
            this.eventsDetails = response.flatMap(parent =>
              (parent.blocks || []).map(block => {
                const startDate: Date = new Date(block.startTime);
                const endDate: Date = new Date(block.endTime);

                // Set `resourceKey` so the event binds to the correct resource row
                const resourceKey: string = parent.rowType === 'Evaluator' ? parent.providerSk : parent.studentSk;
                const resourceType: string = parent.rowType === 'Evaluator' ? 'Evaluator' : 'Student';

                return {
                  id: block.meetingSk ?? `${parent.studentSk}-${block.startTime}`,
                  resourceKey,
                  resourceType,
                  groupSize: null, // not available in block → keep null
                  title: block?.serviceType || block.courseName,
                  start: startDate,
                  end: endDate,
                  location: block?.location, // not available in block
                  description: parent?.studentName || parent?.providerName,
                  language: block?.isProviderSession ? 'EN' : null,
                  serviceType: block?.serviceType,
                  studentMandates: null,
                  dataItem: {
                    ...block,
                    ...parent
                  },
                  isAllDay: false,
                  sessionType: block?.isProviderSession ? 1 : 2,
                  sessionTypeName: block?.isProviderSession ? 'Provider Session' : 'Student Session'
                };
              })
            );
            this.loaderService?.hide();

          });
        } else {

          const mandateSkList: string[] = this.compareMandatesGridView?.length > 0
            ? this.compareMandatesGridView
              .map(item => item?.mandateDetails?.mandateSk)
              .filter(Boolean) : this.editSelectedMandates?.map(item => item?.mandateSk)
                .filter(Boolean);
          const payload: {
            providerSK: string;
            providerName: string;
            startDate: string;
            endDate: string;
            mandateSk: string[];
          } = {
            providerSK: this.user?.providerSk,
            providerName: this.user?.uid,
            startDate: this.isEditingSession ? formatStartToAPI(this.editStartDate) : startOfWorkWeek,
            endDate: this.isEditingSession ? formatStartToAPI(this.editStartDate) : startOfWorkWeek,
            mandateSk: mandateSkList
          }
          this.providerService.getStudentProviderSchedules(payload).pipe(
            finalize(() => {
              this.loaderService?.hide();
            })
          ).subscribe((response: any) => {
            this.bindResources(response);
            this.eventsDetails = response.flatMap(parent =>
              (parent.blocks || []).map(block => {
                const startDate = new Date(block.startTime);
                const endDate = new Date(block.endTime);

                // Set `resourceKey` so the event binds to the correct resource row
                const resourceKey = parent.rowType === 'Provider' ? parent.providerSk : parent.studentSk;
                const resourceType = parent.rowType === 'Provider' ? "Provider" : "Student";

                const formjson: ISchedulerResponse = block?.formJSON ? JSON.parse(block?.formJSON) : null;
                const sessionTypeValue: string | number =
                  typeof formjson?.sessionType === 'number' ? formjson?.sessionType : formjson?.sessionType?.id;
                return {
                  id: block.meetingSk ?? `${parent.studentSk}-${block.startTime}`,
                  resourceKey,
                  resourceType,
                  groupSize: formjson?.groupSize, // not available in block → keep null
                  title: block?.serviceType || block?.courseName,
                  start: startDate,
                  end: endDate,
                  description: parent?.studentName || parent?.providerName,
                  language: block?.isProviderSession ? 'EN' : null,
                  serviceType: block?.serviceType,
                  location: block?.location, // not available in block
                  studentMandates: formjson?.studentMandates,
                  sessionType: sessionTypeValue,
                  dataItem: {
                    ...block,
                    ...parent
                  },
                  isAllDay: false,
                  sessionTypeName: block?.sessionTypeName,
                };
              })
            );
            this.loaderService?.hide();

          });

        }
      }

    })
  }

  onSlotClick(e: any): void {
    if (!e?.start || !e?.end) {
      return;
    }

    this.selectedSlotStart = e.start;
    this.selectedSlotEnd = e.end;

    const mouseEvent = e.originalEvent as MouseEvent;

    // Safe positioning
    this.inlineTop = mouseEvent?.clientY ?? 423;
    this.inlineLeft = mouseEvent?.clientX ?? 882;
    this.checkStatus = true;
  }


  getLocationBySessionType(event: number): boolean {
    if (event === this.iEPMeetingAttendanceNumber || event === this.nYCPSAuthorizedTraining ||
      event === this.meetingWithSchoolStaff)
      return true
    else
      return false
  }
  customFaIcon(icon: IconDefinition): SVGIcon {
    return {
      name: icon.iconName,
      content: `<path d="${icon.icon[4]}" />`,
      viewBox: `0 0 ${icon.icon[0]} ${icon.icon[1]}`,
    };
  }

  onSelectionChange(event: SlotRange): void {
    //Habdle slot selection
  }
  onDateChange(event: DateChangeEvent): void {
    if (this.studentsSelected) {
      const payload: {
        providerSK: string;
        providerName: string;
        startDate: string;
        endDate: string;
        studentSk: string;
        grade?: string;
      } = {
        providerSK: this.user?.providerSk,
        providerName: this.user?.uid,
        startDate: this.isEditingSession ? formatStartToAPI(event?.selectedDate) : startOfWorkWeek,
        endDate: this.isEditingSession ? formatStartToAPI(event?.selectedDate) : startOfWorkWeek,
        studentSk: this.studentSk,
        grade: this.selecteStudentdMandates?.grade,
      }
      this.providerService.getStudentEvaluatorSchedules(payload).pipe(
        finalize(() => {
          this.loaderService?.hide();
        })
      ).subscribe((response: any) => {
        this.bindResources(response);
        this.eventsDetails = response?.flatMap(parent =>
          (parent.blocks || []).map(block => {
            const startDate: Date = new Date(block.startTime);
            const endDate: Date = new Date(block.endTime);

            // Set `resourceKey` so the event binds to the correct resource row
            const resourceKey: string = parent.rowType === 'Evaluator' ? parent.providerSk : parent.studentSk;
            const resourceType: string = parent.rowType === 'Evaluator' ? 'Evaluator' : 'Student';

            return {
              id: block.meetingSk ?? `${parent.studentSk}-${block.startTime}`,
              resourceKey,
              resourceType,
              groupSize: null, // not available in block → keep null
              title: block?.serviceType || block?.courseName,
              start: startDate,
              end: endDate,
              location: block?.location, // not available in block
              studentName: block?.studentName,
              description: parent?.studentName || parent?.providerName,
              language: block?.isProviderSession ? 'EN' : null,
              serviceType: block?.serviceType,
              studentMandates: null,
              dataItem: {
                ...block,
                ...parent
              },
              isAllDay: false,
              sessionType: block?.isProviderSession ? 1 : 2,
              sessionTypeName: block?.isProviderSession ? 'Provider Session' : 'Student Session'
            };
          })
        );
        this.loaderService?.hide();
      });
    }
    else {

      const mandateSkList: string[] = this.compareMandatesGridView?.length > 0
        ? this.compareMandatesGridView
          .map(item => item?.mandateDetails?.mandateSk)
          .filter(Boolean) : this.editSelectedMandates?.map(item => item?.mandateSk)
            .filter(Boolean);
      const payload: {
        providerSK: string;
        providerName: string;
        startDate: string;
        endDate: string;
        mandateSk: string[];
      } = {
        providerSK: this.user?.providerSk,
        providerName: this.user?.uid,
        startDate: this.isEditingSession ? formatStartToAPI(event?.selectedDate) : startOfWorkWeek,
        endDate: this.isEditingSession ? formatStartToAPI(event?.selectedDate) : startOfWorkWeek,
        mandateSk: mandateSkList
      }
      this.providerService.getStudentProviderSchedules(payload).pipe(
        finalize(() => {
          this.loaderService?.hide();
        })
      ).subscribe((response: any) => {
        this.bindResources(response);
        this.eventsDetails = response?.flatMap(parent =>
          (parent.blocks || []).map(block => {
            const startDate: Date = new Date(block.startTime);
            const endDate: Date = new Date(block.endTime);

            // Set `resourceKey` so the event binds to the correct resource row
            const resourceKey: string = parent.rowType === 'Provider' ? parent.providerSk : parent.studentSk;
            const resourceType: string = parent.rowType === 'Provider' ? 'Provider' : 'Student';
            const formjson: any = block?.formJSON ? JSON.parse(block.formJSON) : null;
            return {
              id: block.meetingSk ?? `${parent.studentSk}-${block.startTime}`,
              resourceKey,
              resourceType,
              groupSize: formjson?.groupSize, // not available in block → keep null
              title: block?.serviceType || block?.courseName,
              start: startDate,
              end: endDate,
              description: parent?.studentName || parent?.providerName,
              language: block?.isProviderSession ? 'EN' : null,
              serviceType: block?.serviceType,
              location: block?.location, // not available in block
              studentMandates: formjson?.studentMandates,
              sessionType: formjson?.sessionType?.id,
              dataItem: {
                ...block,
                ...parent
              },
              isAllDay: false,
              sessionTypeName: block?.sessionTypeName,
            };
          })

        );

        this.loaderService?.hide();
      });
      this.cdref?.detectChanges();
    }
  }

  onRemoveResource(resource: any): void {

    const resourceIndex: number = this.resources[0].data.findIndex(
      (r) => r.nycId === resource.nycId
    );
    this.resources[0].data.splice(resourceIndex, 1);
  }



  override afterOnDestroy(): void {
    //
  }
}
